module.exports = __webpack_public_path__ + "static/media/variacoes.0b2dc1d1.gif";